import { useContext } from 'react';
import { ButtonsWrapper } from '@/components/StatsButtons/ButtonsWrapper';
import { StatsContext } from '@/contexts/stats/context';
import { StatsButton } from '@/components/StatsButtons/common';
import { BUTTON_TYPES } from '@/contexts/stats/types';

export const QuarterButtons = () => {
  const { quarterButtons, changeActiveButton } = useContext(StatsContext);
  return (
    <ButtonsWrapper>
      {quarterButtons?.map((quarterButton) => (
        <StatsButton
          isActive={quarterButton.isActive}
          variant={'outlined'}
          disableRipple={quarterButton.isActive}
          key={quarterButton.id}
          onClick={() =>
            changeActiveButton(quarterButton, BUTTON_TYPES.QUARTER)
          }
        >
          {quarterButton.id}
        </StatsButton>
      ))}
    </ButtonsWrapper>
  );
};
